import { GroupInfo, SingleSetting } from "src/components/SettingsEditor";
import { Feature } from "src/states/ApplicationStateFeatures";
import { InputFieldSpec } from "./JobServiceInterface";
import { InputFieldType } from "./JobState";

const inputFieldSpecs: InputFieldSpec[] = [
  {
    title: { da: "Afgangslokationer (lag)", en: "Departure locations (layer)" },
    valueKey: "selectedLayerId_From",
    type: InputFieldType.SelectLayer
  },
  {
    title: { da: "Fra Id (søjle)", en: "From Id (column)" },
    valueKey: "selectedColumnId_From_Id",
    type: InputFieldType.SelectColumn,
    optionsKey: "selectedLayerId_From_Options",
    disAllowDefault: true
  },
  {
    title: { da: "Ank id 1 (søjle)", en: "Dest Id 1 (column)" },
    valueKey: "selectedColumnId_From_DestId_1",
    type: InputFieldType.SelectColumn,
    optionsKey: "selectedLayerId_From_Options",
    disAllowDefault: true
  },
  {
    title: { da: "Ank id 2 (søjle)", en: "Dest Id 2 (column)" },
    valueKey: "selectedColumnId_From_DestId_2",
    type: InputFieldType.SelectColumn,
    optionsKey: "selectedLayerId_From_Options",
  },
  {
    title: { da: "Ank id 3 (søjle)", en: "Dest Id 3 (column)" },
    valueKey: "selectedColumnId_From_DestId_3",
    type: InputFieldType.SelectColumn,
    optionsKey: "selectedLayerId_From_Options",
  },
  {
    title: { da: "Ank id 4 (søjle)", en: "Dest Id 4 (column)" },
    valueKey: "selectedColumnId_From_DestId_4",
    type: InputFieldType.SelectColumn,
    optionsKey: "selectedLayerId_From_Options",
  },
  {
    title: { da: "Ank id 5 (søjle)", en: "Dest Id 5 (column)" },
    valueKey: "selectedColumnId_From_DestId_5",
    type: InputFieldType.SelectColumn,
    optionsKey: "selectedLayerId_From_Options",
  },
  {
    title: { da: "Ankomstlokationer (lag)", en: "Arrival locations (layer)" },
    valueKey: "selectedLayerId_To",
    type: InputFieldType.SelectLayer
  },
  {
    title: { da: "Til Id (søjle)", en: "To Id (column)" },
    valueKey: "selectedColumnId_To_Id",
    type: InputFieldType.SelectColumn,
    optionsKey: "selectedLayerId_To_Options",
    disAllowDefault: true
  },
  {
    title: { da: "Indstillinger", en: "Settings" },
    valueKey: "showSettings",
    type: InputFieldType.Settings
  }
]

const settingsGroups: GroupInfo = [
  {
    key: "tidsvindue",
    da: "Tidsvindue",
    en: "Time Window"
  },
  {
    key: "routing",
    da: "Ruteplanlægning",
    en: "Routing"
  },
  {
    key: "technical",
    da: "Teknisk",
    en: "Technical"
  }
]

const settings: SingleSetting[] = [
  {
    access: Feature.JobModule,
    group: "routing",
    key: "tidsvindue.modsatretning",
    default: false,
    type: "Boolean",
    true: { "da": "Ja", "en": "Yes" },
    false: { "da": "Nej", "en": "No" },
    da: "Modsat retning",
    en: "Reverse direction",
  },
  {
    access: Feature.JobModule,
    group: "routing",
    key: "gangcykel.cykelhastighed",
    default: 15,
    min: 0,
    max: 50,
    type: "Integer",
    suffix: "km/t",
    da: "Cykelhastighed",
    en: "Bike speed",
  },
  {
    access: Feature.JobModule,
    group: "routing",
    key: "gangcykel.ganghastighed",
    default: 4.6,
    min: 0,
    max: 50,
    type: "Float",
    precision: 0.1,
    suffix: "km/t",
    da: "Ganghastighed",
    en: "Walk speed",
  },
  {
    access: Feature.JobModule,
    group: "routing",
    key: "tidsvindue.transportmiddel",
    type: "Select",
    default: "auto",
    da: "Transportmiddel",
    en: "Mode of transport",
    options: [
      { value: "auto", da: "Automatisk", en: "Automatic" },
      { value: "car", da: "Bil", en: "Car" },
      { value: "bicycle", da: "Cykel", en: "Bike" },
      { value: "foot", da: "Til fods", en: "Walking" }
    ],
  },
  {
    access: Feature.JobModule,
    group: "technical",
    key: "technical.viamap.token",
    default: "eyJkcGZ4IjogImpvYnNlcnZpY2UiLCAicmVmIjogIjIiLCAicGFyIjogIiIsICJwcml2cyI6ICJyMVowcjBGMGs2QnRXcVFjT1V5a0IveTZTVXBKdjJRYmd5WGV0cTRIWTRYTy8zWXJXMCtLOXc9PSJ9.QR1rLJ5amfsGEuYhVtMV1Avag4vTdgUreBTeKuyCCFxoejZe+QrOA0uZj9ftw0RsCVWEfoWVc26rTZBmnJeonw",
    type: "String",
    da: "Viamap API token",
    en: "Viamap API token",
  },
  {
    access: Feature.JobModule,
    group: "technical",
    key: "technical.viamap.prefix",
    default: "jobservice",
    type: "String",
    da: "Viamap API prefix",
    en: "Viamap API prefix",
  },
]

export const JobSettingsDef = {
  inputFieldSpecs: inputFieldSpecs,
  settingsGroups: settingsGroups,
  settings: settings,
}

export const JobTypeSettingsDef = {
  inputFieldSpecs: inputFieldSpecs,
  settingsGroups: settingsGroups,
  settings: settings
}